import BaseDataObject from './BaseDataObject';

export default class OriginalJockey extends BaseDataObject {
  getName() {
    return `${this.getString('name')} ${this.getString('surname')}`;
  }

  getShortName() {
    return this.getString('shortName');
  }
}
